document.addEventListener('DOMContentLoaded', function() {
    var showMenuButton = document.getElementById('HeaderMenu-invisible-braces');
    var navMenu = document.querySelector('.eventforhide ul');

    var currentUrl = window.location.href;
    var pathArray = currentUrl.split('/');
    var path = pathArray[pathArray.length - 1];
    try {
      if (path === 'invisible-braces') {
          navMenu.classList.remove('hidden');
      } else {
          navMenu.classList.add('hidden');
      }
    }
    catch(err) {
      console.log(err.message);
    }
      
});